import React from 'react';
import cx from 'classnames';

import Tab from '../../atoms/Tab';

import styles from './TabsList.module.scss';
import usePresenter from './TabsList.presenter';
import getProps from './TabsList.props';
import { TabsListCombinedProps } from './types';


const TabsList: React.FC<TabsListCombinedProps> = (props) => {
  const {
    className,
    classes,
    tabs,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.tabsList;

  const tabViews = tabs?.map((tab, index) => (
    <Tab
      key={index}
      className={cx(styles.tab, classes?.tab)}
      {...internalProps.tab}
      {...tab} />
  )) || [];

  return (
    <div className={cx(currentStyle, className)}>
      {tabViews}
    </div>
  );
};

export default TabsList;

